import Loadable from 'UIComponents/decorators/Loadable';
import { ErrorLoadingAsync } from 'collaboration-sidebar/components/LoadingAsyncComponents';
import { jsx as _jsx } from "react/jsx-runtime";
const EmbeddedComment = Loadable({
  loader: () => import( /* webpackChunkName: "embedded-comment" */'./EmbeddedComment').then(mod => mod.default),
  LoadingComponent: () => null,
  ErrorComponent: ({
    retry
  }) => {
    return /*#__PURE__*/_jsx(ErrorLoadingAsync, {
      retry: retry
    });
  }
});
export default EmbeddedComment;